import { faBars, faThLarge } from "@fortawesome/pro-solid-svg-icons";
import type { HTMLProps } from "react";

import { NoStyleButton } from "@aviary";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./ListGridSelector.styles";

interface Props extends HTMLProps<HTMLDivElement> {
  handleToggle: (isGridView: boolean) => void;
  isGridView?: boolean;
  isDisabled?: boolean;
  arialabels?: {
    listGridSelector?: string;
    listViewButton?: string;
    gridViewButton?: string;
  };
}

const ListGridSelector = ({
  isGridView = false,
  handleToggle,
  isDisabled,
  arialabels = {
    listGridSelector: "Select view type",
    listViewButton: "View products in list view",
    gridViewButton: "View products in grid view",
  },
  ...rest
}: Props) => {
  const handleListClick = () => {
    handleToggle(false);
  };

  const handleGridClick = () => {
    handleToggle(true);
  };

  const buildIconStyles = (isActive: boolean) => {
    return [
      styles.icon.base,
      isActive && styles.icon.isActive,
      isDisabled && styles.icon.isDisabled,
    ];
  };

  return (
    <div css={styles.listGridSelector} aria-label={arialabels.listGridSelector} {...rest}>
      <NoStyleButton
        css={[styles.button.base, isDisabled && styles.button.isDisabled]}
        onClick={handleListClick}
        aria-label={arialabels.listViewButton}
        data-testid="list-view"
        disabled={isDisabled}
      >
        <FontAwesomeIcon css={buildIconStyles(!isGridView)} icon={faBars} />
      </NoStyleButton>
      <NoStyleButton
        css={[styles.button.base, isDisabled && styles.button.isDisabled]}
        onClick={handleGridClick}
        aria-label={arialabels.gridViewButton}
        data-testid="grid-view"
        disabled={isDisabled}
      >
        <FontAwesomeIcon css={buildIconStyles(isGridView)} icon={faThLarge} />
      </NoStyleButton>
    </div>
  );
};

export { ListGridSelector };
